import React, { useState, useEffect } from 'react';
import { db } from '../FireBase'; // Import Firestore
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Container } from 'react-bootstrap';
import bcrypt from 'bcryptjs'; // Import bcrypt
import '../css/LoginPage.css'; // Import the custom CSS file

const LoginPage = ({ setUser }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Check if the user is already logged in
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    const storedUser = sessionStorage.getItem('user');
    
    if (isLoggedIn && storedUser) {
      const userData = JSON.parse(storedUser);
      setUser(userData);
    
      navigate('/dashboard');
    }
  }, [navigate, setUser]);

  // Handle form submission for login
  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    
    try {
      // Query Firestore to check if the email exists
      const q = query(
        collection(db, 'crm_users'),
        where('email', '==', email)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError('Incorrect email or password..');
        return;
      }

      const userDoc = querySnapshot.docs[0];
      const userData = userDoc.data();

      // Compare entered password with hashed password
      const passwordMatch = await bcrypt.compare(password, userData.Password); // Check password hash

      if (!passwordMatch) {
        setError('Incorrect email or password.');
        return;
      }

      // Set the user with their allowed access pages
      const userSession = { uid: userDoc.id, role: userData.role || [] };
      setUser(userSession);

      // Store user data in sessionStorage
      sessionStorage.setItem('isLoggedIn', 'true');
      sessionStorage.setItem('user', JSON.stringify(userSession));
      localStorage.setItem("user", JSON.stringify(userSession));

      // Redirect to dashboard
      navigate('/dashboard');
    } catch (err) {
      setError('Failed to log in. Please try again.');
    }
  };

  return (
    
      <div className="auth-bg">
        <Container className="d-flex justify-content-center align-items-center">
          <div className="login-form">
            <center>
              <img src="/Asset.png" alt="Ps stores" style={{width:'300px'}}/>
              <hr />
            </center>
            <h2>Login</h2>
            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
              {error && <Alert variant="danger">{error}</Alert>}
              <Button variant="danger" type="submit">
                Login
              </Button>
            </Form>
          </div>
        </Container>
      </div>
    
  );
};

export default LoginPage;
